// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"bd9d1a8a","851":"65ec1ca3"}[chunkId] + ".chunk.js";
};